import { createPersistedStore } from "./createPersistedStore.ts";

export const ColorSchemes = [
    { id: "light", description: "Light" },
    { id: "dark", description: "Dark" }
] as const;

export type ColorScheme = (typeof ColorSchemes)[number]["id"];

const STORAGE_KEY = "color-scheme";

function isColorScheme(value: string | null): value is ColorScheme {
    return value !== null && ColorSchemes.some(s => s.id === value);
}

function detectSystemColorScheme(): ColorScheme {
    return typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function applyColorScheme(colorScheme: ColorScheme) {
    document.documentElement.classList.toggle("dark", colorScheme === "dark");
}

const store = createPersistedStore<ColorScheme>({
    storageKey: STORAGE_KEY,
    getFallback: detectSystemColorScheme,
    isValid: isColorScheme,
    apply: applyColorScheme
});

if (typeof window !== "undefined") {
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", store.refresh);
}

export const setColorScheme = store.set;
export const useColorScheme = store.useValue;

export const ColorSchemeSelections = [
    { id: "light", description: "Light" },
    { id: "system", description: "System" },
    { id: "dark", description: "Dark" }
] as const;

export type ColorSchemeSelection = (typeof ColorSchemeSelections)[number]["id"];

export function isColorSchemeSelection(value: string | null): value is ColorSchemeSelection {
    return value !== null && ColorSchemeSelections.some(s => s.id === value);
}

export function useColorSchemeSelection(): ColorSchemeSelection {
    return store.useStoredValue() ?? "system";
}

export function setColorSchemeSelection(selection: ColorSchemeSelection) {
    if (selection === "system") {
        store.clear();
    } else {
        store.set(selection);
    }
}
